<template>
  <div v-if="user">
    <div class="row">
      <div class="col">
        <h1>
          {{ user.name }}
          <router-link
            class="btn btn-primary btn-sm pull-right"
            :to="`/users/${user._id}/edit`"
            v-if="isAdmin"
          >Edit</router-link>
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-4 text-center">
        <img class="img-fluid" :src="user.image">
        <p>
          <span
            v-for="role in user.roles"
            :key="role"
            class="badge badge-dark"
          >{{role.toUpperCase()}}</span>
        </p>
      </div>
      <div class="col col-lg-8">
        <p v-if="isAdmin && user.email">
          <strong>Email:</strong>
          {{ user.email }}
        </p>
        <p v-if="isAdmin && user.gratis && user.gratis.rulesets">
          <strong>Additional Rulesets:</strong>
          {{ user.gratis.rulesets.join() }}
        </p>

        <h5>Achievements</h5>
        <p v-if="user.achievements && user.achievements.length > 0">
          <ez-badges
            v-for="achievement in user.achievements"
            :item="achievement"
            :key="achievement._id"
            badge-type="achievements"
            size="large"
          ></ez-badges>
        </p>
        <p v-else class="fa-dim">
          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
        </p>

        <div
          class="indent"
          v-if="user.characters && user.characters.length > 0 && filteredArrayLengthg0"
        >
          <h3>Characters</h3>
          <div v-for="ruleset in $rpgv.rulesetOptions" :key="ruleset" class="indent">
            <h6 class="c6">{{ruleset}}</h6>
            <strong
              v-for="character in filteredArray(user.characters, ruleset)"
              :key="character._id"
            >
              <router-link
                :to="`/characters/${character._id}/sheet`"
              >{{character.name || 'Character'}}</router-link>
              <!--
              -->
              <span
                v-if="character !== filteredArray(user.characters, ruleset)[filteredArray(user.characters, ruleset).length -1]"
              >,</span>
            </strong>
          </div>
        </div>

        <div class="indent" v-if="user.items && user.items.length > 0 && filteredArrayLengthg0">
          <h3>Items</h3>
          <div v-for="ruleset in $rpgv.rulesetOptions" :key="ruleset" class="indent">
            <h6 class="c6">{{ruleset}}</h6>
            <strong v-for="item in filteredArray(user.items, ruleset)" :key="item._id">
              <router-link :to="`/items/${item._id}`">{{item.name || 'Item'}}</router-link>
              <!--
              -->
              <span
                v-if="item !== filteredArray(user.items, ruleset)[filteredArray(user.items, ruleset).length -1]"
              >,</span>
            </strong>
          </div>
        </div>

        <div class="indent" v-if="user.rules && user.rules.length > 0 && filteredArrayLengthg0">
          <h3>Rules</h3>
          <div v-for="ruleset in $rpgv.rulesetOptions" :key="ruleset" class="indent">
            <h6 class="c6">{{ruleset}}</h6>
            <strong v-for="rule in filteredArray(user.rules, ruleset)" :key="rule._id">
              <router-link :to="`/rules/${rule._id}`">{{rule.name || 'Rule'}}</router-link>
              <!--
              -->
              <span
                v-if="rule !== filteredArray(user.rules, ruleset)[filteredArray(user.rules, ruleset).length -1]"
              >,</span>
            </strong>
          </div>
        </div>

        <div class="indent" v-if="user.spells && user.spells.length > 0 && filteredArrayLengthg0">
          <h3>Spells</h3>
          <div v-for="ruleset in $rpgv.rulesetOptions" :key="ruleset" class="indent">
            <h6 class="c6">{{ruleset}}</h6>
            <strong v-for="spell in filteredArray(user.spells, ruleset)" :key="spell._id">
              <router-link :to="`/spells/${spell._id}`">{{spell.name || 'Spells'}}</router-link>
              <!--
              -->
              <span
                v-if="spell !== filteredArray(user.spells, ruleset)[filteredArray(user.spells, ruleset).length -1]"
              >,</span>
            </strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import EzBadges from "@/components/shared/_VueEzBadges";

export default {
  name: "user-detail",
  components: {
    EzBadges
  },
  props: ["id"],
  watch: {
    $route: "getData"
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.users.current
    })
  },
  methods: {
    ...mapActions({
      usersProfile: "users/profile"
    }),
    filteredArray(arr, ruleset) {
      arr = arr || [];
      return arr.filter(x => x.ruleset === ruleset);
    },
    filteredArrayLengthg0(arr, ruleset) {
      return this.filteredArray(arr, ruleset).length > 0;
    },
    async getData() {
      try {
        await this.usersProfile({ id: this.$route.params.id });
        this.$embers.pageData(this.user.name, this.user.summary);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h6 {
  margin: 0;
}
.indent {
  margin-bottom: 0.5em;
}
</style>
